import { render } from "./PreviewTableComponent.vue?vue&type=template&id=b76b1d44"
import script from "./PreviewTableComponent.vue?vue&type=script&lang=js"
export * from "./PreviewTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__